import moment from 'moment-timezone';
import Service from '@advisor/util/Service';
import {ACCOUNT_PORTFOLIO_TYPE} from '@advisor/util/constants';

const {MS_BASE, MS_SERVICE_TOKEN_BASE, MS_GATEWAY_ADVISOR_KEY} = Service;

export const EST_TIME_ZONE = 'America/New_York';

export const momentForTz = (timeZone = EST_TIME_ZONE) => moment().tz(timeZone);

export const getSpecificTimeZone = (timeZone = EST_TIME_ZONE, format = 'YYYY-MM-DD') =>
  momentForTz(timeZone).format(format);

export const TODAYS_DATE_IN_EST_TIME_ZONE = getSpecificTimeZone();

const scheduler = typeof setImmediate === 'function' ? setImmediate : setTimeout;

/**
 * This waits until all promises flushed
 */
export const flushPromises = () =>
  new Promise((resolve) => {
    scheduler(resolve);
  });

/**
 * On modal default v-clipboard does not work.
 * As it needs element which can be selected or focused, On modal on modal contents can be focused
 * so the default v-clipboard is not working.
 * This function will work for moda
 * l.
 * @param {String} modalPlaceHolderId any Id of parent element on modal
 * @param {String} textToCopy text that need to be copied to clipboard
 */
export const modalCopyToClipboard = (modalPlaceHolderId, textToCopy) => {
  const placeHolder = document.getElementById(modalPlaceHolderId);
  const el = document.createElement('textarea');

  el.value = textToCopy;
  placeHolder.append(el);
  el.select();
  document.execCommand('copy');
  el.remove();
};

export const generateServiceProxyOptions = (defaults = {}, flag = false) => {
  const proxyOptions = {
    baseUrl: defaults?.baseUrl ?? MS_BASE,
    options: defaults?.options ?? {},
  };

  if (flag) {
    proxyOptions.baseUrl = MS_SERVICE_TOKEN_BASE;
    proxyOptions.options = {
      headers: {
        'x-api-key': MS_GATEWAY_ADVISOR_KEY,
      },
    };
  }

  return proxyOptions;
};

/**
 * Change the text "Goal based" label portfolio type to "Time based"
 */
export const checkIfGoalBased = (portfolioType) => {
  if (
    portfolioType?.toLowerCase() === ACCOUNT_PORTFOLIO_TYPE.GOAL_BASED_PORTFOLIO.toLowerCase() ||
    ACCOUNT_PORTFOLIO_TYPE[portfolioType]?.toLowerCase() === ACCOUNT_PORTFOLIO_TYPE.GOAL_BASED_PORTFOLIO.toLowerCase()
  ) {
    return 'Time-based';
  }

  if (
    portfolioType?.toLowerCase() === ACCOUNT_PORTFOLIO_TYPE.RISK_BASED_PORTFOLIO.toLowerCase() ||
    ACCOUNT_PORTFOLIO_TYPE[portfolioType]?.toLowerCase() === ACCOUNT_PORTFOLIO_TYPE.RISK_BASED_PORTFOLIO.toLowerCase()
  ) {
    return 'Risk-based';
  }

  return portfolioType;
};
